module.exports = __webpack_public_path__ + "static/howdoesitwork-Graphic@3x-1a2f4c096dae29461e16237a54c8a288.png";